module.exports = __webpack_public_path__ + "img/brand-black.c5243279.png";